import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

// Mounted once inside the Router. On every route change it recalculates
// ScrollTrigger positions after the new page paints + its (lazy) images start
// loading — otherwise triggers measure against stale layout, the #1 SPA/GSAP bug.
// (Scroll-to-top is handled separately by <ScrollToTop />.)
export default function ScrollRefresh() {
  const { pathname } = useLocation();

  useEffect(() => {
    const t = setTimeout(() => ScrollTrigger.refresh(), 250);
    return () => clearTimeout(t);
  }, [pathname]);

  // Also refresh once everything (fonts/images) has finished loading.
  useEffect(() => {
    const onLoad = () => ScrollTrigger.refresh();
    window.addEventListener('load', onLoad);
    return () => window.removeEventListener('load', onLoad);
  }, []);

  return null;
}
